import { useDeviceId } from "../../navigation/devices";
import { devicesApi } from "../../services/api/devices";
import FileListTabPage from "../files/FileListTabPage";

export default function DeviceFilesTabPage() {
    return <FileListTabPage api={devicesApi.files} ownerId={useDeviceId()} />;
}
